export enum RoomObjectAclGuestType {
  Contact = 'Contact',
}

export enum RoomObjectAclType {
  Content = 'Content',
}
